import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.esm.js';
import React, { useMemo } from 'react';
import { composeRenderProps, Button } from 'react-aria-components';
import _GridListItem from './aria/grid-list/grid-list-item.esm.js';
import { useComponentTheme } from '../../theme/theme.context.esm.js';
import Checkbox from '../checkbox/checkbox.esm.js';

var _excluded = ["className", "children"];
function GridListItem(_ref) {
  var _props$value;
  var _className = _ref.className,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  var textValue = ((_props$value = props.value) === null || _props$value === void 0 ? void 0 : _props$value.label) || props.textValue || (typeof children === 'string' ? children : undefined);
  var theme = useComponentTheme('DropdownItem');
  var classes = useMemo(function () {
    return composeRenderProps(_className, function (className, renderProps) {
      var selectionBehavior = renderProps.selectionBehavior,
        selectionMode = renderProps.selectionMode;
      var classes = theme(_objectSpread2(_objectSpread2({}, renderProps), {}, {
        className: className,
        noCheckboxMode: selectionBehavior === 'replace' && selectionMode === 'multiple' || selectionMode === 'single'
      }));
      return "csg-tw-grid-list-item ".concat(classes);
    });
  }, [_className, theme]);
  return /*#__PURE__*/React.createElement(_GridListItem, _extends({
    textValue: textValue
  }, props, {
    className: classes
  }), function (_ref2) {
    var selectionMode = _ref2.selectionMode,
      selectionBehavior = _ref2.selectionBehavior,
      allowsDragging = _ref2.allowsDragging;
    return /*#__PURE__*/React.createElement(React.Fragment, null, allowsDragging && /*#__PURE__*/React.createElement(Button, {
      slot: "drag"
    }, "\u2261"), selectionMode === 'multiple' && selectionBehavior === 'toggle' ? typeof children === 'string' ? /*#__PURE__*/React.createElement(Checkbox, {
      slot: "selection",
      ellipsis: "1"
    }, children) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Checkbox, {
      slot: "selection",
      className: "w-fit"
    }), children) : children);
  });
}

export { GridListItem as default };
//# sourceMappingURL=grid-list-item.esm.js.map
